import { render } from "./TheHeader.vue?vue&type=template&id=5c2c2624&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"

import "./TheHeader.vue?vue&type=style&index=0&id=5c2c2624&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c2c2624"

export default script